import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// payment_method_controller.js, nested here via payments_helper#payment_method_component,
// auto-selects a newly-added card with jQuery's synthetic `$(".current-payment-method").click()`
// after a successful Stripe tokenization. A synthetic jQuery click never reaches a native
// listener, so that delegated binding stays on jQuery, bound in connect() and unbound in
// disconnect() -- matching prepayment_controller.js's identical shape. Everything inside the
// handler is plain DOM work on this controller's own markup, so it reads native (dataset,
// closest, classList). "active"/"btn-disabled"/"collapsed"/"expanded" stay literal strings: all
// four are shared conventions used by sibling payment-method controllers or reused stylesheet-wide
// under the same name (grepped), not this controller's own to rename.
//
// #pay submits a sibling <form id="finish-order-form"> that sits outside this controller's
// element, so it is reached by id rather than restructuring the HAML.
//
// Send a Gift renders a second pay control in its header next to the panel's; both are payButton
// targets, so pressing either disables both and submits the one order form once.
//
// Every target is optional: this controller also mounts inside
// gives/payments/_payment_info.html.haml, which renders no pay button, promo code or accordion.
export default class extends Controller {
  static get targets() { return ["payButton", "promoCodeInput", "applyPromoCodeButton", "accordionTrigger", "accordionContent"]; }
  static get classes() { return ["applied"]; }

  connect() {
    this.onPaymentMethodClick = (event) => {
      // Prevent the dropdown button from triggering this
      if (event.target.closest("button")) {
        return;
      }

      const target = event.currentTarget;
      const id = target.dataset.id;
      const url = target.parentElement.dataset.url;

      const options = RequestHelper.defaultPatchOptions();
      options.headers = Object.assign({}, options.headers, {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json, text/plain, */*"
      });
      options.body = JSON.stringify({ build: { payment_method_id: id } });

      fetch(url, options).then((response) => {
        if (!response.ok) { throw new Error(response.statusText); }

        document.querySelectorAll(".payment-method-widget").forEach((el) => el.classList.remove("active"));
        target.parentElement.classList.add("active");
      }).catch((error) => {
        console.warn(error.message);
      });
    };
    $("body").on("click.givePayment", ".current-payment-method", this.onPaymentMethodClick);

    this.initAccordion();
    this.onResize = () => this.initAccordion();
    window.addEventListener("resize", this.onResize);
  }

  disconnect() {
    $("body").off("click.givePayment", ".current-payment-method", this.onPaymentMethodClick);
    window.removeEventListener("resize", this.onResize);
  }

  pay(event) {
    event.preventDefault();

    // The pay controls are links, which ignore `disabled`.
    if (this.paying) { return; }
    this.paying = true;

    this.payButtonTargets.forEach((button) => {
      button.classList.add("btn-disabled");
      button.disabled = true;
    });

    const form = document.getElementById("finish-order-form");
    if (form) { form.submit(); }
  }

  togglePromoApply() {
    if (!this.hasApplyPromoCodeButtonTarget) { return; }

    this.applyPromoCodeButtonTarget.disabled = this.promoCodeInputTarget.value === "";
  }

  showPromoCodeForm(event) {
    event.preventDefault();
    document.querySelectorAll(".promo-code").forEach((el) => {
      el.classList.toggle(this.hasAppliedClass ? this.appliedClass : "applied");
    });
  }

  toggleAccordion(event) {
    if (!this.isAccordionWidth()) { return; }

    event.currentTarget.classList.toggle("collapsed");
    if (this.hasAccordionContentTarget) { this.accordionContentTarget.classList.toggle("expanded"); }
  }

  isAccordionWidth() {
    return window.innerWidth <= 802;
  }

  initAccordion() {
    if (!this.hasAccordionTriggerTarget || !this.hasAccordionContentTarget) { return; }

    if (this.isAccordionWidth()) {
      this.accordionTriggerTarget.classList.add("collapsed");
      this.accordionContentTarget.classList.remove("expanded");
    } else {
      this.accordionTriggerTarget.classList.remove("collapsed");
      this.accordionContentTarget.classList.add("expanded");
    }
  }
}
